module.exports = __webpack_public_path__ + "static/media/story-9.7eff66d5.jpg";